module.exports = __webpack_public_path__ + "static/media/emj01.17e4e279.svg";